import { form } from "./form";
export function dialogBuyerRegistration() {
    const dialog =
        document.querySelector<HTMLDialogElement>("#dialog-buyer-reg");

    if (dialog) {
        const detailUrl = dialog.dataset.detailurl as RequestInfo | URL;
        fetch(detailUrl, {
            headers: { "X-Requested-With": "XMLHttpRequest" },
            method: "GET",
            credentials: "same-origin",
        })
            .then((response) => {
                return response.text();
            })
            .then((content) => {
                // Dialog Body mit content befuellen
                const dialogContent = dialog.querySelector(".dialog-content");
                if (dialogContent) {
                    dialogContent.innerHTML = content;
                }
                form();
            });
        dialog.showModal();
    }
}
